(function () {
  'use strict';

  function getHongKongDate(daysToAdd) {
    var now = new Date();
    var dateParts;

    try {
      dateParts = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Asia/Hong_Kong',
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
      }).formatToParts(now);
    } catch (error) {
      now.setDate(now.getDate() + daysToAdd);
      return now;
    }

    var values = {};
    dateParts.forEach(function (part) {
      if (part.type !== 'literal') values[part.type] = Number(part.value);
    });

    return new Date(Date.UTC(values.year, values.month - 1, values.day + daysToAdd, 4));
  }

  function formatHongKongDate(date) {
    try {
      var dateParts = new Intl.DateTimeFormat('zh-HK', {
        timeZone: 'Asia/Hong_Kong',
        month: 'numeric',
        day: 'numeric'
      }).formatToParts(date);
      var values = {};
      dateParts.forEach(function (part) {
        if (part.type !== 'literal') values[part.type] = part.value;
      });
      return values.month + '月' + values.day + '日';
    } catch (error) {
      return (date.getMonth() + 1) + '月' + date.getDate() + '日';
    }
  }

  function updateDeliveryDates(container) {
    var scope = container || document;
    var elements = scope.querySelectorAll('[data-hg-delivery-date]');

    elements.forEach(function (element) {
      var daysToAdd = parseInt(element.getAttribute('data-delivery-days'), 10);
      if (Number.isNaN(daysToAdd)) daysToAdd = 6;
      element.textContent = formatHongKongDate(getHongKongDate(daysToAdd));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      updateDeliveryDates(document);
    });
  } else {
    updateDeliveryDates(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    updateDeliveryDates(event.target);
  });
})();
